module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/10-bf4fd960840e926e68bc4724f4616f2d.png";